import * as Constants from "../../../../../utils/constants"
import { useEditorFile } from "../../../../../hooks/useEditorFile";
import DxmlBreakTableBody from "./DxmlBreakTableBody";
import DxmlElements from "../DxmlElements";

export default function DxmlBreakTable({ editorBreakTable }) {
    const editorBreakTableFirstHeader = editorBreakTable.Items.find(x => x.Type === Constants.editorType.breakTableFirstHeader);
    const editorBreakTableLastFooter = editorBreakTable.Items.find(x => x.Type === Constants.editorType.breakTableLastFooter);
    const editorBreakTableBody = editorBreakTable.Items.find(x => x.Type === Constants.editorType.breakTableBody);
    const { getChildItemsToShow, getKeyById } = useEditorFile();

    return (
        <>
            {
                editorBreakTableFirstHeader && (
                    <DxmlElements editorBaseModel={editorBreakTableFirstHeader} />
                )
            }

            <DxmlBreakTableBody editorBreakTableBody={editorBreakTableBody} />

            {
                editorBreakTableLastFooter && (
                    <DxmlElements editorBaseModel={editorBreakTableLastFooter} />
                )
            }
        </>
    )
}